/**
 * 定制商品
 */

import fetch from '@/plugins/fetch'

import {
  getCityCodeInNoGPSAuthorization,
  isEmptyObject,
  isNonEmptyArray,
  isNullOrEmpty,
  getPosition,
  dateCompare
} from '@/utils'
import { E_ORDER_TYPE } from '@/config'
import { PREFIX_SCC_API } from '@/service'

import B_GOODS from '../goods'
import { setConfirmQuery, goConfirm } from '../2-confirm'

export function checkIfCustomisedGoods(source, saleAttribute) {
  return B_GOODS.isSKUGoods(source, saleAttribute)
}
/**
 * 定制商品取返回的第一个店家内的商品信息
 * @param {string | number} spuId
 * @param {{lng, lat, cityCode}} position
 */
export async function getStoreList(spuId, position) {
  try {
    let url = `${PREFIX_SCC_API}api/spu/queryCustomCmmdtyUnionBusiness.do?spuId=${spuId}`

    if (!isNullOrEmpty(position) && !isEmptyObject(position)) {
      url += `&longitude=${position.lng}&latitude=${position.lat}&city=${position.cityCode}`
    } else {
      // 用户禁止GPS授权 取手动定位的城市 取不到则取cookie.cityCode
      let cityCode = getCityCodeInNoGPSAuthorization()
      url += `&city=${cityCode}`
    }

    const res = await fetch(url)
    const j = await res.json()
    if (+j.code === 1) {
      let d = j.data || {}
      // 新接口
      if (isNonEmptyArray(d)) {
        return d
      }
      if (isNonEmptyArray(d.data)) return d.data
    }
    return []
  } catch (error) {
    throw error
  }
}
/**
 * @typedef {import('@/components/storeInfo/services').storeInfo} storeInfo
 * @param {Array<{}>} storeList
 * @param {string|number} businessId
 * @returns {storeInfo}
 */
export function getStoreInfo(storeList, businessId) {
  const compare = storeList.length > 0
  let storeInfo = null
  if (compare) {
    /** @type import('@/components/storeInfo/services').storeInfo */
    storeInfo = storeList[0]
    if (businessId) {
      const tmpStoreInfo = storeList.find(x => +x.businessKey === +businessId)
      if (tmpStoreInfo) {
        storeInfo = tmpStoreInfo
      }
    }
  }
  return storeInfo
}
/**
 * 下单后有赠品单
 * @param {{spuId,businessId,endTime,relOrderId,businessId,useReplace}} param0
 */
export async function processCustomisedGoods({
  spuId,
  skuId,
  businessId = '',
  endTime,
  relOrderId,
  useReplace = false
}) {
  if (dateCompare(endTime)) {
    let position = await getPosition()
    const storeList = await getStoreList(spuId, position)
    const storeInfo = getStoreInfo(storeList, businessId)
    const query = {
      relOrderId,
      businessKey: businessId,
      skuId,
      ruleId: '',
      ruleType: E_ORDER_TYPE.REWARD_GIFT,
      cmd: 'share',
      sharetype: 0,
      refresh: 'no'
    }
    const { spuId: newSpuId, query: newQuery } = setConfirmQuery({
      spuId,
      storeInfo,
      query
    })
    goConfirm(newSpuId, newQuery, useReplace)
  }
}
